import CollectionManagerDialog from "@/components/CollectionManager";
import HBIcon from "@/components/HBIcon";
import useAppStore from "@/context/store";
import { useMemoizedFn } from "ahooks";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { When } from "react-if";
import styles from "../index.module.less";
export default function CollectionList({
  list,
  current,
  onSelect,
  onCollectionEdit,
  isManageMode,
  isMe,
  hasCollabBoard,
}) {
  const [isExpand, setIsExpand] = useState(false);
  const [showBtn, setShowBtn] = useState(false);
  const { wrapperWidth } = useAppStore(({ wrapperWidth }) => ({
    wrapperWidth,
  }));
  const onCollectionManageClick = useMemoizedFn(() => {
    CollectionManagerDialog.open({
      onCancel() {
        onCollectionEdit();
      },
    });
  });

  const onCreate = useMemoizedFn(() => {
    CollectionManagerDialog.open({
      create: true,
      onCancel() {
        onCollectionEdit();
      },
    });
  });
  useEffect(() => {
    const listDom = document.querySelector(`#collection-list-left`);
    const itemDom = document.querySelector(`.${styles.item}`);
    const itemHeight = getRowHeight(itemDom);

    // 如果整个列表高度大于一行高度，则展示展开收起按钮
    if (listDom?.scrollHeight > itemHeight + 12) {
      setShowBtn(true);
    } else {
      setShowBtn(false);
    }
  }, [list, wrapperWidth]);

  // 一行高度 = 元素高度+marginTop
  const getRowHeight = (element) => {
    if (element) {
      let style = window.getComputedStyle(element);
      return parseFloat(style.height) + parseFloat(style.marginTop);
    }
  };

  return (
    <div className={classNames(styles.collection)}>
      <div className={classNames(styles.collectionList)}>
        <div
          className={classNames(styles.listLeft, {
            [styles.isExpand]: isExpand,
          })}
          id="collection-list-left"
        >
          {/* 只有自己或者专辑列表大于3个才显示全部 */}
          {((isMe && isManageMode) || list?.length > 3) && (
            <div
              className={classNames(styles.item, {
                [styles.selected]: !current,
              })}
              onClick={() => {
                onSelect && onSelect();
              }}
            >
              全部
            </div>
          )}

          {/* 只有自己才能看到多人画板 */}
          {isMe && isManageMode && hasCollabBoard && (
            <div
              className={classNames(styles.item, {
                [styles.selected]: current === "collab",
              })}
              onClick={() => {
                onSelect && onSelect("collab");
              }}
            >
              多人画板
            </div>
          )}

          {list.length > 3 &&
            list.map((item) => (
              <div
                className={classNames(styles.item, {
                  [styles.selected]:
                    String(current) === String(item.collection_id),
                })}
                title={item.title}
                key={item.collection_id}
                onClick={() => {
                  onSelect && onSelect(item.collection_id, item);
                }}
              >
                {item.title}
              </div>
            ))}
        </div>
        <When condition={showBtn && list?.length > 3}>
          <div className={styles.listRight}>
            <div
              className={styles.controlBtn}
              onClick={() => setIsExpand(!isExpand)}
            >
              <HBIcon
                className={styles.icon}
                type={isExpand ? "ic_fold" : "ic_unfold"}
              />
            </div>
          </div>
        </When>
      </div>
      {/* <When condition={!list.length && hasEdit}>
        <div
          className={classNames(styles.item, styles.addBtn)}
          onClick={onCreate}
        >
          <HBIcon type="plus" />
          新建专辑
        </div>
      </When> */}
      <When condition={list?.length > 3 && isManageMode}>
        <div
          className={styles.edit}
          onClick={!list?.length ? onCreate : onCollectionManageClick}
        >
          <HBIcon className={styles.icon} type="ic_edit" />
        </div>
      </When>
    </div>
  );
}
